<template>
	<component class="tag" :is="htmltag" :class="tagClass">
		<span v-html="tag.name"/>
	</component>
</template>
<script>
export default {
	computed: {
		tagClass() {
			let classes = {};
			classes["tag--color--" + this.tag.meta.color] = true;
			return classes;
		}
	},
	props: {
		htmltag: {
			required: false,
			type: String,
			default() {
				return "li";
			}
		},
		tag: {
			required: true,
			type: Object,
		},
	},
};
</script>
